import React from "react";
import ReactDOM from "react-dom/client";
// import { GoogleOAuthProvider } from '@react-oauth/google';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const clientId =
  "332933140681-g2624s0iq393tt08jes4imnibtb8ocdu.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<GoogleOAuthProvider clientId={clientId}>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  //</GoogleOAuthProvider>
);

reportWebVitals();
